import { useMemo } from 'react';

export default function useStableValue<T>(value: T): T {
  const serialized = JSON.stringify(value ?? null);
  return useMemo(() => JSON.parse(serialized) as T, [serialized]);
}
